import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AppCommonCoreModule } from '@common/app-common-core.module';
import { CmsInfoItemsProvider } from '@common/components/info/cms-info-items-provider';
import { CommunityService } from '@common/services/community.service';
import { LanguageService } from '@common/services/language.service';
import { Observable, combineLatest } from 'rxjs';
import { map } from 'rxjs/operators';

@Component({
    selector: 'app-register-btns',
    templateUrl: './register-btns.component.html',
    styleUrls: ['./register-btns.component.scss'],
    imports: [RouterModule, CommonModule, AppCommonCoreModule],
    standalone: true,
})
export class RegisterBtnsComponent implements OnInit {
    $readMoreBtnUrl: Observable<string>;

    @Input()
    stacked: boolean = false;

    @Input()
    grey: boolean = false;

    communityCode: string;

    constructor(
        private communityService: CommunityService,
        public languageService: LanguageService,
        private cmsInfoItemsProvider: CmsInfoItemsProvider,
    ) {
        this.communityCode = communityService.communityCode;
    }

    ngOnInit(): void {
        this.$readMoreBtnUrl = combineLatest([
            this.communityService.currentAuctionOpenForDecisions$,
        ]).pipe(
            map((openForDecisions) => {
                const suffix = openForDecisions
                    ? 'acceptation'
                    : 'registration';

                const item = this.cmsInfoItemsProvider
                    .GetItems(suffix)
                    .find((i) => i.id === 'already-registered');

                return !item
                    ? null
                    : `/${this.communityCode}/${
                          this.languageService.currentLanguageCode
                      }/info/${item.url ? item.url : item.id}`;
            }),
        );
    }
}
